import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { CommonModelResponse, User, CurrentUser } from '../../models';
import { map } from "rxjs/operators";
import { JwtHelperService } from '@auth0/angular-jwt';
import { Router } from '@angular/router';

@Injectable()
export class AuthenticationService {
 

    public isloggedIn = false;
    private jwtHelper: JwtHelperService = new JwtHelperService();
    private redirectUrl = '';
    private loginUrl = '/login';
    constructor(private http: HttpClient) {
        if (localStorage.getItem('currentUser') && localStorage.getItem('currentUser') !== '') {
            this.isloggedIn = true;
        }
    }

    public forgotUserName(block: string, flat: string, fuEmail: string): any {
        const body: any = {
            Block:block,Flat:flat,Email:fuEmail
        };
        return this.http.post<any>(environment.apiUrl + 'api/ForgotUsername', body,
            {
                headers: new HttpHeaders().set('Content-Type', 'application/json')
            }).pipe(
                map(data => {
                    return data;
                }));
    }

    public forgotPassword(userName: string): any {
        const body: any = {
            Username: userName
        };
        return this.http.post<any>(environment.apiUrl + 'api/ForgotPassword', body,
            {
                headers: new HttpHeaders().set('Content-Type', 'application/json')
            }).pipe(
                map(data => {
                    return data;
                }));
    }

    public AuthenticateUser(username: string, password: string): Observable<CurrentUser> {
        const body: any = {
            Username: username,
            Password: password
        };
        return this.http.post<CurrentUser>(environment.apiUrl + 'api/CustomerLogin', body,
            {
                headers: new HttpHeaders().set('Content-Type', 'application/json')
            }).pipe();
    }

    public AuthenticateUserReadOnly(id: string): Observable<CurrentUser> {
        return this.http.get<CurrentUser>(environment.apiUrl + 'api/LoginReadonly?id=' + id,
            {
                headers: new HttpHeaders().set('Content-Type', 'application/json')
            }).pipe();
    }

    public setLoginDetails(user: CurrentUser): User {
        if (user && user.access_token) {
            localStorage.setItem('currentUser', JSON.stringify(user));
            this.isloggedIn = true;
            const data = this.jwtHelper.decodeToken(user.access_token);
            return <User>data;
        }
        else {
            this.isloggedIn = false;
        }
        return null;
    }

    public getAuthToken(): string {
        if (localStorage.getItem('currentUser') && localStorage.getItem('currentUser') !== '') {
            const data = JSON.parse(localStorage.getItem('currentUser'));
            return data.access_token;
        }
        return '';
    }

    refreshToken(): Observable<CurrentUser> {
        let currentUser = this.getCurrentUser();
        let token = currentUser.refresh_token;
        return this.http.post<CurrentUser>(environment.apiUrl + 'api/RefreshToken', { 'token': token }, {
            headers: new HttpHeaders().set('Authorization', 'Bearer ' + this.getAuthToken())
        })
            .pipe(
                map(user => {
                    if (user && user.access_token) {
                        localStorage.setItem('currentUser', JSON.stringify(user));
                        return <CurrentUser>user;
                    }
                    return null;
                }));
    }

    public isUserLoggedIn(): boolean {
        return this.isloggedIn;
    }

    public getLoginUrl(): string {
        return this.loginUrl;
    }

    public getRedirectUrl(): string {
        return this.redirectUrl;
    }

    public setRedirectUrl(url: string): void {
        this.redirectUrl = url;
    }

    public getCurrentUser(): CurrentUser {
        if (localStorage.getItem('currentUser') && localStorage.getItem('currentUser') !== '') {
            const data = JSON.parse(localStorage.getItem('currentUser'));
            return data;
        }
        return null;
    }

    public getUserInfo(): User {
        if (localStorage.getItem('currentUser') && localStorage.getItem('currentUser') !== '') {
            const data = JSON.parse(localStorage.getItem('currentUser'));
            if (data && data.access_token) {
                const user = this.jwtHelper.decodeToken(data.access_token);
                return user;
            }
            return null;
        }
        return null;
    }

    public logoutUser(router: Router): void {
        const user: User = this.getUserInfo();
        localStorage.clear();
        this.isloggedIn = false;        
        router.navigate(['/login']);
    }
}
